
import { loadStripe } from "@stripe/stripe-js";
import { db, auth, functions } from "./firebase";
import { collection, addDoc, onSnapshot } from "@firebase/firestore";
import { httpsCallable } from "@firebase/functions";

// Chave pública fornecida.
const STRIPE_PUBLIC_KEY = "pk_live_51ShyGEC6C0LvwAHlaJhfj3eD81VH3qSlZCRhemfqUZrpXD3v2nd6YFULnRE0RccGwAMuDW4c07PnasRlqvquM1lT00BmwEW2LF";

export const getStripe = () => {
  return loadStripe(STRIPE_PUBLIC_KEY);
};

export const createCheckoutSession = async (priceId: string) => {
  const user = auth.currentUser;
  if (!user) throw new Error("Usuário não autenticado");

  const checkoutSessionsRef = collection(db, "customers", user.uid, "checkout_sessions");

  try {
    const docRef = await addDoc(checkoutSessionsRef, {
      price: priceId,
      success_url: window.location.origin,
      cancel_url: window.location.origin,
      allow_promotion_codes: true,
      mode: 'subscription',
    });

    onSnapshot(docRef, (snap) => {
      const { error, url } = snap.data() || {};
      
      if (error) {
        console.error("Erro no Checkout:", error);
        alert(`Ocorreu um erro: ${error.message}`);
      }
      
      if (url) {
        window.location.assign(url);
      }
    });

  } catch (error) {
    console.error("Erro ao iniciar checkout:", error);
    throw error;
  }
};

export const createPortalSession = async () => {
  const user = auth.currentUser;
  if (!user) throw new Error("Usuário não autenticado");

  try {
    // Chama a Cloud Function fornecida pela extensão do Stripe
    const functionRef = httpsCallable(functions, 'ext-firestore-stripe-payments-createPortalLink');
    
    const { data }: any = await functionRef({
      returnUrl: window.location.origin,
    });

    if (data?.url) {
      window.location.assign(data.url);
    } else {
      throw new Error("URL do portal não encontrada.");
    }
  } catch (error) {
    console.error("Erro ao abrir portal:", error);
    alert("Erro ao abrir gerenciamento de assinatura. Tente novamente.");
    throw error;
  }
};